// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"a5795b0e","977":"47dc5a81"}[chunkId] + ".chunk.js";
};